import { index, Options } from 'shared/assets/styles';
import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${index(Options.DOWNLOAD_APP_BANNER)};

  padding: ${({ theme }) => `${theme.spacing(10)} ${theme.spacing(8)} 0`};

  background: ${({ theme }) => theme.palette.background.paper};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};

  text-align: center;
`;

export const IconContainer = styled.span`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing(3)};

  font-size: 5.6rem;
  line-height: 62.5%;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StoreLink = styled.a`
  display: block;
  margin-top: ${({ theme }) => theme.spacing(5)};

  border-radius: ${({ theme }) => theme.spacing(1)};
  text-decoration: none;
`;

export const StoreBadge = styled.img`
  display: block;
  height: 4.8rem;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing(7.5)};
`;

export const ImageLink = styled.a``;

export const Image = styled.img`
  display: block;
  max-width: 100%;
`;
